// extracted by mini-css-extract-plugin
export default {"root":"PickupInfo_root__MYUnV","heading":"PickupInfo_heading__TVSF8 h4","address":"PickupInfo_address__0epv7 marketplaceBodyFontStyles"};